import { useEffect, useState } from "react";
import { getMe, updateUser } from "../../features/search/service/user-service";
import { getRoleById } from "../../features/search/service/role-service";
import { User } from "../../shared/types/user";
import { Role } from "../../shared/types/role";
import InputComponent from "../../components/input/input";
import ButtonComponent from "../../components/button/button";
import { MenuTop } from '../../components/menu/top/menu-top';
import { useTranslation } from "../../shared/i18n/i18n-context";
import './styles/profile.css';

export const Profile = () => {
    const { t } = useTranslation('profile');
    const { t: commonT } = useTranslation('common');
    const [me, setMe] = useState<User | null>(null);
    const [meRole, setMeRole] = useState<Role | null>(null);
    const [currentPassword, setCurrentPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getMe();
                setMe(userData);

                // Buscar a role pelo role_id
                if (userData.role_id) {
                    const roleData = await getRoleById(userData.role_id);
                    setMeRole(roleData);
                }
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error);
            }
        };
        fetchUser();
    }, []);

    const handleChangePassword = async () => {
        if (!currentPassword || !newPassword || !confirmPassword) {
            return;
        }

        if (newPassword !== confirmPassword) {
            return;
        }

        if (newPassword.length < 6) {
            return;
        }

        if (currentPassword === newPassword) {
            return;
        }

        setLoading(true);

        try {
            const userData: any = {
                name: me?.name!,
                email: me?.email!,
                password: newPassword,
                roleId: me?.role_id,
                companyId: me?.companyId
            };

            const response = await updateUser(me?.id!, userData);
            
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');

            if (response) {
                setMe(response);
            }
        } catch (error) {
            console.error('❌ Erro ao alterar senha:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <MenuTop />
            <div className="profile-container">
                <h1>{t('title')}</h1>

                <div className="user-info-section">
                    <h2>{t('userInformation')}</h2>
                    
                    <div className="info-field">
                        <label>{t('name')}</label>
                        <span>{me?.name || commonT('loading')}</span>
                    </div>

                    <div className="info-field">
                        <label>{t('email')}</label>
                        <span>{me?.email || commonT('loading')}</span>
                    </div>

                    {me?.company && (
                        <div className="info-field">
                            <label>{t('company')}</label>
                            <span>{me.company.name || commonT('notAvailable')}</span>
                        </div>
                    )}

                    {meRole && (
                        <div className="info-field">
                            <label>{t('role')}</label>
                            <span>{meRole.name || commonT('notAvailable')}</span>
                        </div>
                    )}
                </div>

                <div className="change-password-section">
                    <h2>{t('changePassword')}</h2>

                    <InputComponent 
                        id="id-input-current-password" 
                        label={t('currentPassword')} 
                        type="password"
                        value={currentPassword} 
                        onChange={(event) => setCurrentPassword(event.target.value)} 
                    />

                    <InputComponent 
                        id="id-input-new-password" 
                        label={t('newPassword')} 
                        type="password"
                        value={newPassword} 
                        onChange={(event) => setNewPassword(event.target.value)} 
                    />

                    <InputComponent 
                        id="id-input-confirm-password" 
                        label={t('confirmNewPassword')} 
                        type="password"
                        value={confirmPassword} 
                        onChange={(event) => setConfirmPassword(event.target.value)} 
                    />

                    <div className="password-requirements">
                        <p>{t('passwordRequirement')}</p>
                    </div>

                    <div className="button-container">
                        <ButtonComponent
                            label={loading ? t('changing') : t('changePassword')}
                            onClick={handleChangePassword}
                            disabled={loading}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
